module.exports = __webpack_public_path__ + "media/images/emblems/Rumisberg-coat_of_arms-ff4fa67c86d8c43efa679fcf6c343424.svg";